import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '@/types/common';

export interface UIState {
  showErrorModal: boolean;
  errorTitle?: string;
  errorMessage?: string;
  i18nKey?: string;
  silent?: boolean;
  navigateOnClose?: string;
  errorEyebrow?: string;
  errorButtonText?: string;
  errorIcon?: string;
  isWaf?: boolean;
}

const initialState: UIState = {
  showErrorModal: false,
  errorTitle: '',
  errorMessage: '',
  i18nKey: '',
  navigateOnClose: undefined,
  errorEyebrow: undefined,
  errorButtonText: undefined,
  errorIcon: undefined,
  isWaf: false,
};

const ui = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    showErrorModal: (
      state,
      action: PayloadAction<{
        title?: string;
        message?: string;
        i18nKey?: string;
        silent?: boolean;
        navigateOnClose?: string;
        eyebrow?: string;
        buttonText?: string;
        icon?: string;
        isWaf?: boolean;
      }>
    ) => {
      // A WAF-blocked modal is authoritative: once it is showing, ignore any
      // subsequent generic error dispatches so they can't overwrite it.
      if (state.showErrorModal && state.isWaf && !action.payload.isWaf) {
        return;
      }
      if (!action.payload.silent) {
        state.showErrorModal = true;
      }
      state.errorTitle = action.payload.title || '';
      state.errorMessage = action.payload.message || '';
      state.i18nKey = action.payload.i18nKey || '';
      state.silent = action.payload.silent || false;
      state.navigateOnClose = action.payload.navigateOnClose;
      state.errorEyebrow = action.payload.eyebrow;
      state.errorButtonText = action.payload.buttonText;
      state.errorIcon = action.payload.icon;
      state.isWaf = action.payload.isWaf || false;
    },
    hideErrorModal: state => {
      state.showErrorModal = false;
      state.isWaf = false;
    },
    clearError: state => {
      state.errorTitle = '';
      state.errorMessage = '';
      state.i18nKey = '';
      state.silent = false;
      state.navigateOnClose = undefined;
      state.errorEyebrow = undefined;
      state.errorButtonText = undefined;
      state.errorIcon = undefined;
      state.isWaf = false;
    },
  },
});

export const uiActions = ui.actions;

export const { showErrorModal, hideErrorModal, clearError } = ui.actions;

export const uiSelector = (state: RootState) => state.ui;

export default ui.reducer;
